import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../../../../VirtualVideoTest/Components/Progress/ProgressBar';

function AudioLevel({ publisher }) {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!publisher) return;
    let movingAvg = null;

    function trackAudioLevelChange(event) {
      if (movingAvg === null || movingAvg <= event.audioLevel) {
        movingAvg = event.audioLevel;
      } else {
        movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
      }

      let logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
      logLevel = Math.min(Math.max(logLevel, 0), 1);
      setLevel(logLevel * 100);
      return logLevel;
    }

    publisher.on('audioLevelUpdated', trackAudioLevelChange);

    return () => {
      if (publisher) {
        publisher.off('audioLevelUpdated', trackAudioLevelChange);
      }
    };
  }, [publisher]);

  return <ProgressBar progress={level} height={6} />;
}

AudioLevel.propTypes = {
  publisher: PropTypes.object,
};

export default AudioLevel;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MediaSettings/AudioSettings/AudioLevel.jsx